module.exports = __webpack_public_path__ + "static/media/alert-close.3fbe815f.svg";